export default __webpack_public_path__ + "static/media/header-V60.7c7b7786.jpg";